import { Button } from 'design-system';
import { ChevronRight } from 'lucide-react';

import { MonthlyRecapArticleModal } from '@/features/markets/components/MonthlyRecapArticle/MonthlyRecapArticleModal';
import type { MonthlyRecapsArticle } from '@/features/monthly-recaps';
import { useDisclosure } from '@/shared/hooks/useDisclosure';

export const FeedArticleModalLink = ({
  article,
  CTALabel
}: {
  article: MonthlyRecapsArticle;
  CTALabel?: string;
}) => {
  const { isOpen, open, close } = useDisclosure();
  const [groupName, fileName] = article.file.split('/');

  return (
    <>
      <Button
        data-ph-capture-attribute-component-type='feed-article'
        data-ph-capture-attribute-file-name={fileName}
        data-ph-capture-attribute-group-name={groupName}
        variant='link'
        onClick={open}
      >
        {CTALabel ?? 'See the article'}
        <ChevronRight
          aria-hidden='true'
          className='size-[1em]'
        />
      </Button>
      {isOpen && (
        <MonthlyRecapArticleModal
          article={article}
          onClose={close}
        />
      )}
    </>
  );
};
